import {
  LOADING_ABSTRACT,
  RECEIVED_ABSTRACT,
  RECEIVED_ABSTRACT_FAILED,
} from '../../actions/types';

const defaultState = {
  pii: {},
  eid: {},
  doi: {},
};

export default function abstracts(state = defaultState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case LOADING_ABSTRACT: {
      const newState = { ...state };
      const { id, idType } = payload;
      newState[idType][id] = { isLoading: true };
      return newState;
    }
    case RECEIVED_ABSTRACT: {
      const newState = { ...state };
      const { id, idType, data } = payload;
      newState[idType][id] = { isLoading: false, data };
      return newState;
    }
    case RECEIVED_ABSTRACT_FAILED: {
      const newState = { ...state };
      const { id, idType } = payload;
      newState[idType][id] = { isLoading: false, failed: true };
      return newState;
    }
    default: {
      return state;
    }
  }
}
